import React from "react";

export type MscWizardAction =
    { type: 'SET_SUCHWOERTER', value: string}
    | { type: 'SET_ADRESSEN_AUSWAHL', value: LimitedResult<MscAdresse>}
    | { type: 'SET_ADRESSE_AUSGEWAEHLT', value: MscAdresse}
    | { type: 'SET_KONTAKT_VERSANDART', value: MscVersandart}
    | { type: 'SET_KONTAKT_EMAIL', value: string}
    | { type: 'SET_KONTAKT_NUMMER', value: string}
    | { type: 'SET_STEP', value: MscWizardSteps }
    | { type: 'ABONIERE' }
    | { type: 'ABONIEREN_ERFOLGREICH' }
    | { type: 'ABONIEREN_FEHLGESCHLAGEN' }
    | { type: 'RESET' }

export interface MscWizardProps extends React.HTMLAttributes<HTMLDivElement> {
    state: MscWizard
    dispatch: React.Dispatch<MscWizardAction>
}

export type MscWizardSteps = 'adresse' | 'kontakt' | 'captchure' | 'summary' | 'quittung';

export type MscWizardAboState = undefined | 'aboniere' | 'abonieren_erfolgreich' | 'abonieren_fehlgeschlagen';

export interface MscWizard {
    loading: boolean
    suchewoerter: string
    vorschlaegeAdressen: null | LimitedResult<MscAdresse>
    ausgewaehlteAdresse: MscAdresse | null
    kontakt: MscKontakt,
    abonierenState: MscWizardAboState
    step: MscWizardSteps
}

export interface MscAdresse {
    id: number,
    postleitzahl: string,
    ort: string,
    strasse: string | null,
    hausnummer: string | null,
}

export interface LimitedResult<T> {
    limit: number,
    offset: number,
    total: number,
    data: Array<T>
}

export enum MscVersandart {
    EMAIL = 'EMAIL',
    MOBIL = 'MOBIL'
}

export interface MscKontakt {
    versandart: MscVersandart
    nummer: string,
    email: string,
    valide: boolean
}